<template>
  <div no-body class="my-1 p-1 bg-white">
    <div header-tag="header" class="p-1" role="tab">
      <b-button
        v-b-toggle="ReportType"
        block
        class="d-flex collapseHeadStyle"
        @click="isVisibleMERSProperty = !isVisibleMERSProperty"
      >
        <p class="mb-0 text-dark font-weight-bold">MERS System Lien Search</p>
        <strong class="ml-auto"><i :class="`fa fa-angle-${isVisibleMERSProperty ? 'up' : 'down'} text-dark`"></i></strong>
      </b-button>
    </div>
    <b-collapse :id="ReportType" visible>
      <div v-if="MERS_DATA.length" class="mx-2 my-2 baseContentFont">
        <b-row class="my-2 ml-0">
          <b-col md="10"><BaseELabel :label="`Result for ${MERS_LABEL}: ${RESULT}`" /></b-col>
          <b-col v-if="isBorrowerMERS">
            <div>{{ MERS_DATA[0].propertyAddress }}</div>
            <div>{{ MERS_DATA[0].address }}</div>
          </b-col>
          <b-col v-else>{{ MERS_DATA[0].ssn }}</b-col>
        </b-row>
        <div v-if="!MESSAGE">
          <div
            v-for="(item, index) in MERS_DATA"
            :key="index"
            class="border my-2 py-1 baseContentFont"
          >
          <b-row class="mx-1">
            <b-col md="4"><b>Borrower: </b>{{ formatData(item.borrower) }}</b-col>
            <b-col md="4"><b>MIN Number: </b>{{ formatData(item.min) }}</b-col>
            <b-col md="4"><b>MIN Status: </b><span class="wordBreak">{{ formatData(item.status) }}</span></b-col>
          </b-row>
          <b-row class="mx-1">
            <b-col md="4"><b>Lien Type: </b>{{ formatData(item.lienType) }}</b-col>
            <b-col md="4"><b>Loan Amount: </b>{{ formatData(item.loanAmount) }}</b-col>
            <b-col md="4"><b>Registration Date: </b>{{ formatData(item.registrationDate) }}</b-col>
          </b-row>
          <b-row class="mx-1">
            <b-col md="4"><b>Foreclosure Status: </b><span class="wordBreak">{{ formatData(item.foreclosureStatus) }}</span></b-col>
            <b-col md="4"><b>Note Holder: </b>{{ formatData(item.noteHolder) }}</b-col>
            <b-col md="4"><b>Note Date: </b>{{ formatData(item.noteDate) }}</b-col>
          </b-row>
          <b-row class="mx-1">
            <b-col md="4"><b>Owner Occupied: </b>{{ formatData(item.ownerOccupied) }}</b-col>
            <b-col md="4"><b>Investor: </b><span class="wordBreak">{{ formatData(item.investor) }}</span></b-col>
            <b-col md="4"><b>Servicer: </b><span class="wordBreak">{{ formatData(item.servicer) }}</span></b-col>
          </b-row>
          </div>
        </div>

        <CustomMessage  v-else :custom-msg="MESSAGE"/>

      </div>
      <NoRecordFound v-else class="mx-1"></NoRecordFound>

    </b-collapse>
  </div>
</template>

<script>
import NoRecordFound from '@/src/components/_norecord-found.vue'
import { uppercase } from '@/src/utils/filters'
import CustomMessage from '@/src/components/_custom-message.vue'

export default {
  components: {
    NoRecordFound,
    CustomMessage
  },
  filters: {
    uppercase,
  },
  props: {
    mersResponse: {
      type: Object,
      default: () => {},
    },
    mersLabel: {
      type: String,
      default: '',
    },
    reportType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isVisibleMERSProperty: false,
    }
  },
  computed: {
    MERS_DATA() {
      return this.mersResponse.mersResponse || []
    },
    MERS_LABEL() {
      return this.mersLabel
    },
    ReportType() {
      return this.reportType
    },
    isBorrowerMERS() {
      return this.MERS_LABEL === 'SSN'
    },
    RESULT() {
      let repType = this.isBorrowerMERS ? 'borrower' : this.ReportType
      let result = ''
      switch (repType) {
        case 'borrower':
          result = this.mersResponse.ssn
            ? 'XXX-XX-' + this.mersResponse.ssn.substring(7, 11)
            : null
          break
        case 'property':
          result = this.mersResponse.address ? uppercase(this.mersResponse.address) : null
          break
      }
      return result
    },
    MESSAGE() {
      return this.MERS_DATA.length === 1 && this.MERS_DATA[0].message !== null
        ? this.MERS_DATA[0].message
        : null
    },
  },
  methods: {
    formatData(value) {
      return value || ''
    },
  },
}
</script>


<style lang="scss" scoped>
@import 'src/design/_redesign.scss';
.collapseHeadStyle {
  background-color: $color-raisin-40 !important;
  border: none;
}

.wordBreak {
  word-break: break-all;
}
</style>
